import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers, faUsersSlash, faUserLock, faUsersBetweenLines } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { api, getToken } from "../../../../services/apis/auth-api/apiUrl";
import { GET_USERS_ANALYTICS_END_POINT } from "../../../../config/config";
import { faCircleNotch, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { AxiosError } from "axios";

interface userAnalyticsProps {
    active_accounts : number,
    inactive_accounts : number,
    unverified_accounts : number,
    total_accounts : number
}

export default function UsersDetails () {

    const [analytics, setAnalytics] = useState<userAnalyticsProps>({
        active_accounts : 0,
        inactive_accounts : 0,
        unverified_accounts : 0,
        total_accounts : 0
    });
    const [loading, setLoading] = useState<boolean>(true);
    const [stat, setStat] = useState({
        success : true,
        msg : ''
    });

    useEffect(()=>{
        const getUsersAnalytics = async() => {
            try{
                const analytics = await api.get(GET_USERS_ANALYTICS_END_POINT, {
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                setAnalytics(analytics.data);
                setLoading(false);
            }catch(e){
                const error = (e as AxiosError);
                setLoading(false);
                if(error.response?.status === 401){
                    setStat({success: false, msg : 'Unauthorized'})
                }else{
                    setStat({success: false, msg : 'Error occured'})
                }
            }
        }
        getUsersAnalytics();
    },[]);

    return (
        <div className="flex gap-4 w-full">
            <div className="card">
                <div className="text-lg">
                  Total active accounts
                </div>
                <div className="text-5xl flex">
                    <div className="w-full text-center">
                        {loading ? (
                            <FontAwesomeIcon className="animate-spin text-blue-400 cursor-progress" icon={faCircleNotch} />
                        ) : (
                            <>
                                {!stat.success ? (
                                    <div className="text-red-500">
                                        <FontAwesomeIcon className="animate-pulse" icon={faTriangleExclamation} />
                                    </div>
                                ) : (
                                    <>{analytics?.active_accounts}</>
                                )}
                            </>
                        )}
                    </div>
                    <div className="ms-auto text-orange-500">
                        <FontAwesomeIcon icon={faUsers} />
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="text-lg">
                  Total inactive accounts
                </div>
                <div className="text-5xl flex">
                    <div className="w-full text-center">
                        {loading ? (
                            <FontAwesomeIcon className="animate-spin text-blue-400 cursor-progress" icon={faCircleNotch} />
                        ) : (
                            <>
                                {!stat.success ? (
                                        <div className="text-red-500">
                                            <FontAwesomeIcon className="animate-pulse" icon={faTriangleExclamation} />
                                        </div>
                                    ) : (
                                        <>{analytics?.inactive_accounts}</>
                                )}
                            </>
                        )}
                    </div>
                    <div className="ms-auto text-gray-500">
                        <FontAwesomeIcon icon={faUsersSlash} />
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="text-lg">
                  Total unverified accounts
                </div>
                <div className="text-5xl flex">
                    <div className="w-full text-center">
                        {loading ? (
                            <FontAwesomeIcon className="animate-spin text-blue-400 cursor-progress" icon={faCircleNotch} />
                        ) : (
                            <>
                                {!stat.success ? (
                                        <div className="text-red-500">
                                            <FontAwesomeIcon className="animate-pulse" icon={faTriangleExclamation} />
                                        </div>
                                    ) : (
                                        <>{analytics?.unverified_accounts}</>
                                )}
                            </>
                        )}
                    </div>
                    <div className="ms-auto text-yellow-500">
                        <FontAwesomeIcon icon={faUserLock} />
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="text-lg">
                  Total accounts
                </div>
                <div className="text-5xl flex">
                    <div className="w-full text-center">
                        {loading ? (
                            <FontAwesomeIcon className="animate-spin text-blue-400 cursor-progress" icon={faCircleNotch} />
                        ) : (
                            <>
                                {!stat.success ? (
                                        <div className="text-red-500">
                                            <FontAwesomeIcon className="animate-pulse" icon={faTriangleExclamation} />
                                        </div>
                                    ) : (
                                        <>{analytics?.total_accounts}</>
                                )}
                            </>
                        )}
                    </div>
                    <div className="ms-auto text-blue-900">
                        <FontAwesomeIcon icon={faUsersBetweenLines} />
                    </div>
                </div>
            </div>
        </div>
    );
}